import { call, put, takeLatest } from "redux-saga/effects";
import {
  createPaperCurriculumStart,
  createPaperCurriculumSuccess,
  createPaperCurriculumFailure,
  createPaperStart,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpCreatePaperCurriculum } from "../../../services/paper";

export function* handleCreateCurriculum({ payload }) {
  const { data, callback } = payload;
  let curriculumFile = data?.curriculumUrl;
  const response = yield call(httpCreatePaperCurriculum, curriculumFile);
  const { success, raw, message } = response;

  if (success) {
    yield put(createPaperCurriculumSuccess());
    let modData = { ...data, curriculumUrl: raw?.id };
    yield put(createPaperStart({ data: modData, callback }));
  } else {
    yield put(createPaperCurriculumFailure());
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onCreatePaperCurriculum() {
  yield takeLatest(createPaperCurriculumStart.type, handleCreateCurriculum);
}
